//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
/* eslint-disable no-confusing-arrow */
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref, computed, onMounted, getCurrentInstance } from '@vue/composition-api'
import { required, emailValidator, minLengthValidator } from '@core/utils/validation'
import { useRouter, formatPhoneNumber, formatEmail, formatButtonText } from '@core/utils'
import themeConfig from '@themeConfig'
import store from '@/store'
import { useUtils } from '@core/libs/i18n'
import usePhone from '@core/utils/usePhone'
import useCryptoJs from '@core/utils/useCryptoJs'
import useLogData from '@core/utils/useLogData'
import { sendCodeSMSUser, sendCodeEmailUser } from '@api'

export default {
  setup() {
    const { router } = useRouter()
    const { t } = useUtils()
    const { phoneCodeOptions, formatNumber } = usePhone()
    const { encrypt } = useCryptoJs()
    const { logData, currentLogData, updateLogData } = useLogData()
    const vm = getCurrentInstance().proxy

    const loginForm = ref(null)
    const passwordInput = ref(null)

    const isPhoneVisible = ref(false)
    const isPasswordVisible = ref(false)
    const errorMessages = ref([])

    const isFormValid = computed(() => {
      if (logData.value.password && minLengthValidator(logData.value.password, 6) === true) return true

      return false
    })

    const loginSubmit = async () => {
      if (loginForm.value.validate()) {
        const body = {
          code: logData.value.type === 'EMAIL' ? logData.value.code : logData.value.fullPhone,
          type: logData.value.type,
          join_game: logData.value.joinGame,
          match_code: logData.value.matchCode,
          reservation_code: logData.value.reservationCode,
          login_route: logData.value.loginRoute,
          password: logData.value.password,
        }
        const encryptBody = encrypt(body)

        const userAbility = [
          {
            action: 'manage',
            subject: 'all',
          },
        ]
        vm.$ability.update(userAbility)

        // remove team
        store.dispatch('auth/loginUserAction', {
          data: encryptBody,
          redirect: logData.value.redirect,
          facility: logData.value.facility,
          field: logData.value.field,
          date: logData.value.date,
          time: logData.value.time,
          slot: logData.value.slot,
          pay: logData.value.pay,
          reservationCode: logData.value.reservationCode,
          showPay: logData.value.showPay,
          team: logData.value.team,
          chooseTeam: logData.value.chooseTeam,
          payType: logData.value.payType,
        })
      }
    }

    const onAnotherAccount = async () => {
      /* logData.value.type = ''
      logData.value.code = ''
      logData.value.fullPhone = ''
      logData.value.phoneCode = ''
      await updateLogData(logData.value) */
      router.push({ name: 'auth-login-phone-email' })
    }

    const onForgotPassword = () => {
      router.push({ name: 'auth-forgot-password' })
    }

    const onLoginCode = async typeSelected => {
      let respSend = null
      let info = null
      let encryptBody = null
      logData.value.encode = logData.value.type
      logData.value.type = typeSelected
      logData.value.type_selected = typeSelected

      if (typeSelected === 'PHONE_NUMBER') {
        info = {
          phone_number: logData.value.phone_number,
        }
        encryptBody = encrypt(info)
        respSend = await sendCodeSMSUser(encryptBody)
      } else {
        info = {
          email: logData.value.email,
        }
        encryptBody = encrypt(info)
        respSend = await sendCodeEmailUser(encryptBody)
      }

      if (respSend.ok) {
        updateLogData(logData.value)
        router.push({ name: 'auth-access-code' })
      }
    }

    onMounted(async () => {
      Object.assign(logData.value, currentLogData.value)
      isPhoneVisible.value = logData.value.type === 'PHONE_NUMBER'
      setTimeout(() => {
        passwordInput.value.focus()
      }, 500)
    })

    return {
      loginForm,
      passwordInput,
      logData,
      isPasswordVisible,
      errorMessages,
      isFormValid,
      onForgotPassword,
      isPhoneVisible,
      phoneCodeOptions,

      // themeConfig
      appName: themeConfig.app.name,
      appLogoTitle: themeConfig.app.logoTitle,

      loginSubmit,
      onLoginCode,
      onAnotherAccount,
      formatNumber,
      formatEmail,
      formatButtonText,
      formatPhoneNumber,
      t,

      validators: {
        required,
        emailValidator,
        minLengthValidator,
      },

      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
